/* eslint-disable */

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CreativeReviewRouteImport } from './routes/creative-review'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as BriefRouteImport } from './routes/brief'
import { Route as AudiencePlannerRouteImport } from './routes/audience-planner'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as CreativesIndexRouteImport } from './routes/creatives/index'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns/index'
import { Route as AudiencesIndexRouteImport } from './routes/audiences/index'
import { Route as ReportsSpilloverRouteImport } from './routes/reports/spillover'
import { Route as ReportsPerfHaloRouteImport } from './routes/reports/perf-halo'
import { Route as ReportsMarkupRouteImport } from './routes/reports/markup'
import { Route as ReportsDeliveryRouteImport } from './routes/reports/delivery'
import { Route as CreativesNewRouteImport } from './routes/creatives/new'
import { Route as CampaignsNewRouteImport } from './routes/campaigns/new'
import { Route as CampaignsCampaignIdRouteImport } from './routes/campaigns/$campaignId'
import { Route as BackendVenuesRouteImport } from './routes/backend/venues'
import { Route as BackendSystemHealthRouteImport } from './routes/backend/system-health'
import { Route as BackendProductionsRouteImport } from './routes/backend/productions'
import { Route as BackendPixelsRouteImport } from './routes/backend/pixels'
import { Route as BackendPipelineRouteImport } from './routes/backend/pipeline'
import { Route as BackendEventsRouteImport } from './routes/backend/events'
import { Route as BackendDataPipelineRouteImport } from './routes/backend/data-pipeline'
import { Route as BackendCapiForwardingRouteImport } from './routes/backend/capi-forwarding'
import { Route as BackendCapiRouteImport } from './routes/backend/capi'
import { Route as BackendBackfillRouteImport } from './routes/backend/backfill'
import { Route as BackendAlertsRouteImport } from './routes/backend/alerts'
import { Route as AudiencesNewRouteImport } from './routes/audiences/new'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminRemediationsRouteImport } from './routes/admin/remediations'
import { Route as AdminProviderDriftRouteImport } from './routes/admin/provider-drift'
import { Route as AdminLogsRouteImport } from './routes/admin/logs'
import { Route as AdminInvoicesRouteImport } from './routes/admin/invoices'
import { Route as AdminConfigRouteImport } from './routes/admin/config'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminAlertsRouteImport } from './routes/admin/alerts'
import { Route as CreativesCreativeIdAssetsRouteImport } from './routes/creatives/$creativeId.assets'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativeReviewRoute = CreativeReviewRouteImport.update({
  id: '/creative-review',
  path: '/creative-review',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const BriefRoute = BriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => rootRouteImport,
} as any)
const AudiencePlannerRoute = AudiencePlannerRouteImport.update({
  id: '/audience-planner',
  path: '/audience-planner',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativesIndexRoute = CreativesIndexRouteImport.update({
  id: '/creatives/',
  path: '/creatives/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => rootRouteImport,
} as any)
const AudiencesIndexRoute = AudiencesIndexRouteImport.update({
  id: '/audiences/',
  path: '/audiences/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsSpilloverRoute = ReportsSpilloverRouteImport.update({
  id: '/reports/spillover',
  path: '/reports/spillover',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsPerfHaloRoute = ReportsPerfHaloRouteImport.update({
  id: '/reports/perf-halo',
  path: '/reports/perf-halo',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsMarkupRoute = ReportsMarkupRouteImport.update({
  id: '/reports/markup',
  path: '/reports/markup',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsDeliveryRoute = ReportsDeliveryRouteImport.update({
  id: '/reports/delivery',
  path: '/reports/delivery',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativesNewRoute = CreativesNewRouteImport.update({
  id: '/creatives/new',
  path: '/creatives/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsNewRoute = CampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsCampaignIdRoute = CampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendVenuesRoute = BackendVenuesRouteImport.update({
  id: '/backend/venues',
  path: '/backend/venues',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendSystemHealthRoute = BackendSystemHealthRouteImport.update({
  id: '/backend/system-health',
  path: '/backend/system-health',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendProductionsRoute = BackendProductionsRouteImport.update({
  id: '/backend/productions',
  path: '/backend/productions',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendPixelsRoute = BackendPixelsRouteImport.update({
  id: '/backend/pixels',
  path: '/backend/pixels',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendPipelineRoute = BackendPipelineRouteImport.update({
  id: '/backend/pipeline',
  path: '/backend/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendEventsRoute = BackendEventsRouteImport.update({
  id: '/backend/events',
  path: '/backend/events',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendDataPipelineRoute = BackendDataPipelineRouteImport.update({
  id: '/backend/data-pipeline',
  path: '/backend/data-pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendCapiForwardingRoute = BackendCapiForwardingRouteImport.update({
  id: '/backend/capi-forwarding',
  path: '/backend/capi-forwarding',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendCapiRoute = BackendCapiRouteImport.update({
  id: '/backend/capi',
  path: '/backend/capi',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendBackfillRoute = BackendBackfillRouteImport.update({
  id: '/backend/backfill',
  path: '/backend/backfill',
  getParentRoute: () => rootRouteImport,
} as any)
const BackendAlertsRoute = BackendAlertsRouteImport.update({
  id: '/backend/alerts',
  path: '/backend/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const AudiencesNewRoute = AudiencesNewRouteImport.update({
  id: '/audiences/new',
  path: '/audiences/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRemediationsRoute = AdminRemediationsRouteImport.update({
  id: '/admin/remediations',
  path: '/admin/remediations',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProviderDriftRoute = AdminProviderDriftRouteImport.update({
  id: '/admin/provider-drift',
  path: '/admin/provider-drift',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLogsRoute = AdminLogsRouteImport.update({
  id: '/admin/logs',
  path: '/admin/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
  id: '/admin/invoices',
  path: '/admin/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminConfigRoute = AdminConfigRouteImport.update({
  id: '/admin/config',
  path: '/admin/config',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAlertsRoute = AdminAlertsRouteImport.update({
  id: '/admin/alerts',
  path: '/admin/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativesCreativeIdAssetsRoute =
  CreativesCreativeIdAssetsRouteImport.update({
    id: '/creatives/$creativeId/assets',
    path: '/creatives/$creativeId/assets',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/account': typeof AccountRoute
  '/audience-planner': typeof AudiencePlannerRoute
  '/brief': typeof BriefRoute
  '/connect': typeof ConnectRoute
  '/creative-review': typeof CreativeReviewRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/alerts': typeof AdminAlertsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/config': typeof AdminConfigRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/logs': typeof AdminLogsRoute
  '/admin/provider-drift': typeof AdminProviderDriftRoute
  '/admin/remediations': typeof AdminRemediationsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/audiences/new': typeof AudiencesNewRoute
  '/backend/alerts': typeof BackendAlertsRoute
  '/backend/backfill': typeof BackendBackfillRoute
  '/backend/capi': typeof BackendCapiRoute
  '/backend/capi-forwarding': typeof BackendCapiForwardingRoute
  '/backend/data-pipeline': typeof BackendDataPipelineRoute
  '/backend/events': typeof BackendEventsRoute
  '/backend/pipeline': typeof BackendPipelineRoute
  '/backend/pixels': typeof BackendPixelsRoute
  '/backend/productions': typeof BackendProductionsRoute
  '/backend/system-health': typeof BackendSystemHealthRoute
  '/backend/venues': typeof BackendVenuesRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/campaigns/new': typeof CampaignsNewRoute
  '/creatives/new': typeof CreativesNewRoute
  '/reports/delivery': typeof ReportsDeliveryRoute
  '/reports/markup': typeof ReportsMarkupRoute
  '/reports/perf-halo': typeof ReportsPerfHaloRoute
  '/reports/spillover': typeof ReportsSpilloverRoute
  '/audiences/': typeof AudiencesIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/creatives/': typeof CreativesIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/creatives/$creativeId/assets': typeof CreativesCreativeIdAssetsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/account': typeof AccountRoute
  '/audience-planner': typeof AudiencePlannerRoute
  '/brief': typeof BriefRoute
  '/connect': typeof ConnectRoute
  '/creative-review': typeof CreativeReviewRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/alerts': typeof AdminAlertsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/config': typeof AdminConfigRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/logs': typeof AdminLogsRoute
  '/admin/provider-drift': typeof AdminProviderDriftRoute
  '/admin/remediations': typeof AdminRemediationsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/audiences/new': typeof AudiencesNewRoute
  '/backend/alerts': typeof BackendAlertsRoute
  '/backend/backfill': typeof BackendBackfillRoute
  '/backend/capi': typeof BackendCapiRoute
  '/backend/capi-forwarding': typeof BackendCapiForwardingRoute
  '/backend/data-pipeline': typeof BackendDataPipelineRoute
  '/backend/events': typeof BackendEventsRoute
  '/backend/pipeline': typeof BackendPipelineRoute
  '/backend/pixels': typeof BackendPixelsRoute
  '/backend/productions': typeof BackendProductionsRoute
  '/backend/system-health': typeof BackendSystemHealthRoute
  '/backend/venues': typeof BackendVenuesRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/campaigns/new': typeof CampaignsNewRoute
  '/creatives/new': typeof CreativesNewRoute
  '/reports/delivery': typeof ReportsDeliveryRoute
  '/reports/markup': typeof ReportsMarkupRoute
  '/reports/perf-halo': typeof ReportsPerfHaloRoute
  '/reports/spillover': typeof ReportsSpilloverRoute
  '/audiences': typeof AudiencesIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/creatives': typeof CreativesIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/creatives/$creativeId/assets': typeof CreativesCreativeIdAssetsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/account': typeof AccountRoute
  '/audience-planner': typeof AudiencePlannerRoute
  '/brief': typeof BriefRoute
  '/connect': typeof ConnectRoute
  '/creative-review': typeof CreativeReviewRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/alerts': typeof AdminAlertsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/config': typeof AdminConfigRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/logs': typeof AdminLogsRoute
  '/admin/provider-drift': typeof AdminProviderDriftRoute
  '/admin/remediations': typeof AdminRemediationsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/audiences/new': typeof AudiencesNewRoute
  '/backend/alerts': typeof BackendAlertsRoute
  '/backend/backfill': typeof BackendBackfillRoute
  '/backend/capi': typeof BackendCapiRoute
  '/backend/capi-forwarding': typeof BackendCapiForwardingRoute
  '/backend/data-pipeline': typeof BackendDataPipelineRoute
  '/backend/events': typeof BackendEventsRoute
  '/backend/pipeline': typeof BackendPipelineRoute
  '/backend/pixels': typeof BackendPixelsRoute
  '/backend/productions': typeof BackendProductionsRoute
  '/backend/system-health': typeof BackendSystemHealthRoute
  '/backend/venues': typeof BackendVenuesRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/campaigns/new': typeof CampaignsNewRoute
  '/creatives/new': typeof CreativesNewRoute
  '/reports/delivery': typeof ReportsDeliveryRoute
  '/reports/markup': typeof ReportsMarkupRoute
  '/reports/perf-halo': typeof ReportsPerfHaloRoute
  '/reports/spillover': typeof ReportsSpilloverRoute
  '/audiences/': typeof AudiencesIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/creatives/': typeof CreativesIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/creatives/$creativeId/assets': typeof CreativesCreativeIdAssetsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/account'
    | '/audience-planner'
    | '/brief'
    | '/connect'
    | '/creative-review'
    | '/login'
    | '/reset-password'
    | '/admin/alerts'
    | '/admin/audit'
    | '/admin/config'
    | '/admin/invoices'
    | '/admin/logs'
    | '/admin/provider-drift'
    | '/admin/remediations'
    | '/admin/roles'
    | '/admin/users'
    | '/audiences/new'
    | '/backend/alerts'
    | '/backend/backfill'
    | '/backend/capi'
    | '/backend/capi-forwarding'
    | '/backend/data-pipeline'
    | '/backend/events'
    | '/backend/pipeline'
    | '/backend/pixels'
    | '/backend/productions'
    | '/backend/system-health'
    | '/backend/venues'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/creatives/new'
    | '/reports/delivery'
    | '/reports/markup'
    | '/reports/perf-halo'
    | '/reports/spillover'
    | '/audiences/'
    | '/campaigns/'
    | '/creatives/'
    | '/reports/'
    | '/creatives/$creativeId/assets'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/account'
    | '/audience-planner'
    | '/brief'
    | '/connect'
    | '/creative-review'
    | '/login'
    | '/reset-password'
    | '/admin/alerts'
    | '/admin/audit'
    | '/admin/config'
    | '/admin/invoices'
    | '/admin/logs'
    | '/admin/provider-drift'
    | '/admin/remediations'
    | '/admin/roles'
    | '/admin/users'
    | '/audiences/new'
    | '/backend/alerts'
    | '/backend/backfill'
    | '/backend/capi'
    | '/backend/capi-forwarding'
    | '/backend/data-pipeline'
    | '/backend/events'
    | '/backend/pipeline'
    | '/backend/pixels'
    | '/backend/productions'
    | '/backend/system-health'
    | '/backend/venues'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/creatives/new'
    | '/reports/delivery'
    | '/reports/markup'
    | '/reports/perf-halo'
    | '/reports/spillover'
    | '/audiences'
    | '/campaigns'
    | '/creatives'
    | '/reports'
    | '/creatives/$creativeId/assets'
  id:
    | '__root__'
    | '/'
    | '/accept-invite'
    | '/account'
    | '/audience-planner'
    | '/brief'
    | '/connect'
    | '/creative-review'
    | '/login'
    | '/reset-password'
    | '/admin/alerts'
    | '/admin/audit'
    | '/admin/config'
    | '/admin/invoices'
    | '/admin/logs'
    | '/admin/provider-drift'
    | '/admin/remediations'
    | '/admin/roles'
    | '/admin/users'
    | '/audiences/new'
    | '/backend/alerts'
    | '/backend/backfill'
    | '/backend/capi'
    | '/backend/capi-forwarding'
    | '/backend/data-pipeline'
    | '/backend/events'
    | '/backend/pipeline'
    | '/backend/pixels'
    | '/backend/productions'
    | '/backend/system-health'
    | '/backend/venues'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/creatives/new'
    | '/reports/delivery'
    | '/reports/markup'
    | '/reports/perf-halo'
    | '/reports/spillover'
    | '/audiences/'
    | '/campaigns/'
    | '/creatives/'
    | '/reports/'
    | '/creatives/$creativeId/assets'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInviteRoute: typeof AcceptInviteRoute
  AccountRoute: typeof AccountRoute
  AudiencePlannerRoute: typeof AudiencePlannerRoute
  BriefRoute: typeof BriefRoute
  ConnectRoute: typeof ConnectRoute
  CreativeReviewRoute: typeof CreativeReviewRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AdminAlertsRoute: typeof AdminAlertsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminConfigRoute: typeof AdminConfigRoute
  AdminInvoicesRoute: typeof AdminInvoicesRoute
  AdminLogsRoute: typeof AdminLogsRoute
  AdminProviderDriftRoute: typeof AdminProviderDriftRoute
  AdminRemediationsRoute: typeof AdminRemediationsRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AudiencesNewRoute: typeof AudiencesNewRoute
  BackendAlertsRoute: typeof BackendAlertsRoute
  BackendBackfillRoute: typeof BackendBackfillRoute
  BackendCapiRoute: typeof BackendCapiRoute
  BackendCapiForwardingRoute: typeof BackendCapiForwardingRoute
  BackendDataPipelineRoute: typeof BackendDataPipelineRoute
  BackendEventsRoute: typeof BackendEventsRoute
  BackendPipelineRoute: typeof BackendPipelineRoute
  BackendPixelsRoute: typeof BackendPixelsRoute
  BackendProductionsRoute: typeof BackendProductionsRoute
  BackendSystemHealthRoute: typeof BackendSystemHealthRoute
  BackendVenuesRoute: typeof BackendVenuesRoute
  CampaignsCampaignIdRoute: typeof CampaignsCampaignIdRoute
  CampaignsNewRoute: typeof CampaignsNewRoute
  CreativesNewRoute: typeof CreativesNewRoute
  ReportsDeliveryRoute: typeof ReportsDeliveryRoute
  ReportsMarkupRoute: typeof ReportsMarkupRoute
  ReportsPerfHaloRoute: typeof ReportsPerfHaloRoute
  ReportsSpilloverRoute: typeof ReportsSpilloverRoute
  AudiencesIndexRoute: typeof AudiencesIndexRoute
  CampaignsIndexRoute: typeof CampaignsIndexRoute
  CreativesIndexRoute: typeof CreativesIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  CreativesCreativeIdAssetsRoute: typeof CreativesCreativeIdAssetsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creative-review': {
      id: '/creative-review'
      path: '/creative-review'
      fullPath: '/creative-review'
      preLoaderRoute: typeof CreativeReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brief': {
      id: '/brief'
      path: '/brief'
      fullPath: '/brief'
      preLoaderRoute: typeof BriefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audience-planner': {
      id: '/audience-planner'
      path: '/audience-planner'
      fullPath: '/audience-planner'
      preLoaderRoute: typeof AudiencePlannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creatives/': {
      id: '/creatives/'
      path: '/creatives'
      fullPath: '/creatives/'
      preLoaderRoute: typeof CreativesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audiences/': {
      id: '/audiences/'
      path: '/audiences'
      fullPath: '/audiences/'
      preLoaderRoute: typeof AudiencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/spillover': {
      id: '/reports/spillover'
      path: '/reports/spillover'
      fullPath: '/reports/spillover'
      preLoaderRoute: typeof ReportsSpilloverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/perf-halo': {
      id: '/reports/perf-halo'
      path: '/reports/perf-halo'
      fullPath: '/reports/perf-halo'
      preLoaderRoute: typeof ReportsPerfHaloRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/markup': {
      id: '/reports/markup'
      path: '/reports/markup'
      fullPath: '/reports/markup'
      preLoaderRoute: typeof ReportsMarkupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/delivery': {
      id: '/reports/delivery'
      path: '/reports/delivery'
      fullPath: '/reports/delivery'
      preLoaderRoute: typeof ReportsDeliveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creatives/new': {
      id: '/creatives/new'
      path: '/creatives/new'
      fullPath: '/creatives/new'
      preLoaderRoute: typeof CreativesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/new': {
      id: '/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof CampaignsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$campaignId': {
      id: '/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof CampaignsCampaignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/venues': {
      id: '/backend/venues'
      path: '/backend/venues'
      fullPath: '/backend/venues'
      preLoaderRoute: typeof BackendVenuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/system-health': {
      id: '/backend/system-health'
      path: '/backend/system-health'
      fullPath: '/backend/system-health'
      preLoaderRoute: typeof BackendSystemHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/productions': {
      id: '/backend/productions'
      path: '/backend/productions'
      fullPath: '/backend/productions'
      preLoaderRoute: typeof BackendProductionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/pixels': {
      id: '/backend/pixels'
      path: '/backend/pixels'
      fullPath: '/backend/pixels'
      preLoaderRoute: typeof BackendPixelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/pipeline': {
      id: '/backend/pipeline'
      path: '/backend/pipeline'
      fullPath: '/backend/pipeline'
      preLoaderRoute: typeof BackendPipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/events': {
      id: '/backend/events'
      path: '/backend/events'
      fullPath: '/backend/events'
      preLoaderRoute: typeof BackendEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/data-pipeline': {
      id: '/backend/data-pipeline'
      path: '/backend/data-pipeline'
      fullPath: '/backend/data-pipeline'
      preLoaderRoute: typeof BackendDataPipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/capi-forwarding': {
      id: '/backend/capi-forwarding'
      path: '/backend/capi-forwarding'
      fullPath: '/backend/capi-forwarding'
      preLoaderRoute: typeof BackendCapiForwardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/capi': {
      id: '/backend/capi'
      path: '/backend/capi'
      fullPath: '/backend/capi'
      preLoaderRoute: typeof BackendCapiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/backfill': {
      id: '/backend/backfill'
      path: '/backend/backfill'
      fullPath: '/backend/backfill'
      preLoaderRoute: typeof BackendBackfillRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backend/alerts': {
      id: '/backend/alerts'
      path: '/backend/alerts'
      fullPath: '/backend/alerts'
      preLoaderRoute: typeof BackendAlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audiences/new': {
      id: '/audiences/new'
      path: '/audiences/new'
      fullPath: '/audiences/new'
      preLoaderRoute: typeof AudiencesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/remediations': {
      id: '/admin/remediations'
      path: '/admin/remediations'
      fullPath: '/admin/remediations'
      preLoaderRoute: typeof AdminRemediationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/provider-drift': {
      id: '/admin/provider-drift'
      path: '/admin/provider-drift'
      fullPath: '/admin/provider-drift'
      preLoaderRoute: typeof AdminProviderDriftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/logs': {
      id: '/admin/logs'
      path: '/admin/logs'
      fullPath: '/admin/logs'
      preLoaderRoute: typeof AdminLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/invoices': {
      id: '/admin/invoices'
      path: '/admin/invoices'
      fullPath: '/admin/invoices'
      preLoaderRoute: typeof AdminInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/config': {
      id: '/admin/config'
      path: '/admin/config'
      fullPath: '/admin/config'
      preLoaderRoute: typeof AdminConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/alerts': {
      id: '/admin/alerts'
      path: '/admin/alerts'
      fullPath: '/admin/alerts'
      preLoaderRoute: typeof AdminAlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creatives/$creativeId/assets': {
      id: '/creatives/$creativeId/assets'
      path: '/creatives/$creativeId/assets'
      fullPath: '/creatives/$creativeId/assets'
      preLoaderRoute: typeof CreativesCreativeIdAssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  AccountRoute: AccountRoute,
  AudiencePlannerRoute: AudiencePlannerRoute,
  BriefRoute: BriefRoute,
  ConnectRoute: ConnectRoute,
  CreativeReviewRoute: CreativeReviewRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AdminAlertsRoute: AdminAlertsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminConfigRoute: AdminConfigRoute,
  AdminInvoicesRoute: AdminInvoicesRoute,
  AdminLogsRoute: AdminLogsRoute,
  AdminProviderDriftRoute: AdminProviderDriftRoute,
  AdminRemediationsRoute: AdminRemediationsRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminUsersRoute: AdminUsersRoute,
  AudiencesNewRoute: AudiencesNewRoute,
  BackendAlertsRoute: BackendAlertsRoute,
  BackendBackfillRoute: BackendBackfillRoute,
  BackendCapiRoute: BackendCapiRoute,
  BackendCapiForwardingRoute: BackendCapiForwardingRoute,
  BackendDataPipelineRoute: BackendDataPipelineRoute,
  BackendEventsRoute: BackendEventsRoute,
  BackendPipelineRoute: BackendPipelineRoute,
  BackendPixelsRoute: BackendPixelsRoute,
  BackendProductionsRoute: BackendProductionsRoute,
  BackendSystemHealthRoute: BackendSystemHealthRoute,
  BackendVenuesRoute: BackendVenuesRoute,
  CampaignsCampaignIdRoute: CampaignsCampaignIdRoute,
  CampaignsNewRoute: CampaignsNewRoute,
  CreativesNewRoute: CreativesNewRoute,
  ReportsDeliveryRoute: ReportsDeliveryRoute,
  ReportsMarkupRoute: ReportsMarkupRoute,
  ReportsPerfHaloRoute: ReportsPerfHaloRoute,
  ReportsSpilloverRoute: ReportsSpilloverRoute,
  AudiencesIndexRoute: AudiencesIndexRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
  CreativesIndexRoute: CreativesIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  CreativesCreativeIdAssetsRoute: CreativesCreativeIdAssetsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
